import { render } from "./positionAdd.vue?vue&type=template&id=a2a2f2e4&ts=true"
import script from "./positionAdd.vue?vue&type=script&lang=ts"
export * from "./positionAdd.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__